export default __webpack_public_path__ + "3d2b63f2196067e95338198ba9e84f78.svg";